import React, { useState } from 'react';

const AddHonorModal = ({ onClose, onAdd }) => {
  const [formData, setFormData] = useState({
    title: '',
    year: '',
    document: null
  });

  const handleInputChange = (field, value) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onAdd(formData);
  };

  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFormData(prev => ({
        ...prev,
        document: file
      }));
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 w-full max-w-lg mx-4">
        <div className="flex justify-between items-center border-b border-[#E6E6E6] pb-6 mb-6">
          <h2 className="text-[16px] font-bold text-[#3C3C3C]">ADD HONOURS & AWARDS</h2>
          <div className="flex gap-2">
            <button onClick={onClose} className="px-4 py-2 border border-[#E6E6E6] bg-white text-[#1E1E1E] rounded-lg">Cancel</button>
            <button onClick={handleSubmit} className="px-4 py-2 bg-[#2283FF] text-white rounded-lg">Save</button>
          </div>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6">
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-xs font-bold text-[#3C3C3C] mb-2">ADD TITLE</label>
              <input
                type="text"
                value={formData.title}
                onChange={(e) => handleInputChange("title", e.target.value)}
                placeholder="ex: Coach of the year"
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 text-[#1A212FB2] text-[14px] placeholder:text-[#1A212F66]"
              />
            </div>
            <div>
              <label className="block text-xs font-bold text-[#3C3C3C] mb-2">YEAR</label>
              <div className="relative">
                <input
                  type="number"
                  value={formData.year}
                  onChange={(e) => handleInputChange("year", e.target.value)}
                  placeholder="YYYY"
                  min="1900"
                  max="2030"
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 text-[#1A212FB2] text-[14px] placeholder:text-[#1A212F66]"
                />
                <svg className="absolute right-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                </svg>
              </div>
            </div>
          </div>

          <div>
            <button
              type="button"
              onClick={() => document.getElementById('honor-document').click()}
              className="w-fit px-4 py-2 border border-[#E6E6E6] bg-white text-[#1E1E1E] rounded-lg flex items-center gap-2"
            >
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M13 9V11.6667C13 12.0203 12.8595 12.3594 12.6095 12.6095C12.3594 12.8595 12.0203 13 11.6667 13H2.33333C1.97971 13 1.64057 12.8595 1.39052 12.6095C1.14048 12.3594 1 12.0203 1 11.6667V9M10.3333 4.33333L7 1M7 1L3.66667 4.33333M7 1V9" stroke="#2C2C2C" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
              Upload document
            </button>
            <input
              id="honor-document"
              type="file"
              onChange={handleFileUpload}
              className="hidden"
              accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
            />
            {formData.document && (
              <p className="text-sm text-gray-600 mt-2">Selected: {formData.document.name}</p>
            )}
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddHonorModal; 